import React, { useEffect, useState } from "react";
import "./AchievementPage.scss";
import Loader from "../../reusableComponents/Loader";
import { useDispatch, useSelector } from "react-redux";
import Certificates from "../Achievements/Certificates";
import HeadAndDesc from "../../components/ReusableComponents/HeadAndDesc";
import RequestPayout from "../profile/RequestPayout";
import { dollarUS, formatDateTime } from "../../utilities/formatters";
import PayoutTable from "../profile/PayoutTable";
import { Typography } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import {
  getPayoutVerificationStatus,
  requestPayout,
} from "../../store/reducers/payoutReducer";
import downloadIcon from "../../assets/images/download.svg";
import useMobile from "../../hooks/useMobile";
import { ReactComponent as CardIcon } from "../../assets/icons/NewIcons/cardIcon.svg";
import { ReactComponent as EditSquareIcon } from "../../assets/icons/NewIcons/editSquareIcon.svg";
import Title from "../../components/ReusableComponents/title";
import MobileTabs from "../../reusableComponents/MobileTabs/MobileTabs";
import UpdatedCheckoutPage from "../UpdatedCheckoutPage/UpdatedCheckoutPage";
import { getUserSettingDispatch } from "../../store/reducers/userProfileReducer";
import { tokenConfig } from "../../store/reducers/tokenReducer";
import { myStore } from "../..";
import axios from "axios";
const AchievementPage = () => {
  const { payoutAccess, payout_list } = useSelector((state) => state.payout);

  const [mainTabination, setMainTabination] = useState(0);
  const [activeTab, setActiveTab] = useState(mainTabination);
  const loader = useSelector((state) => state.loader.is_loading);
  const [openLoader, setOpenLoader] = useState(loader);
  const [requestPayout, setRequestPayout] = useState(false);
  const isMobile = useMobile();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getUserSettingDispatch());
    dispatch(getPayoutVerificationStatus());
  }, [dispatch]);
  const StatFormatter = (data) => {
    const Stat = data.toLowerCase();

    const classList = Stat.includes("approved")
      ? "StatusPassed"
      : Stat.includes("interview")
      ? "StatusProgress"
      : "rejected";

    return <div className={`Status ${classList}`}>{data}</div>;
  };
  useEffect(() => {
    setOpenLoader(loader);
  }, [loader]);
  const tabItems = [
    {
      name: "Achievements",
      value: 0,
    },
    ...(payoutAccess
      ? [
          {
            name: "Payout",
            value: 1,
          },
        ]
      : []),
  ];
  useEffect(() => {
    setMainTabination(activeTab);
  }, [activeTab]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [payoutList, setPayoutList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchPayouts = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.get(
        `/get/payouts/`,
        tokenConfig(myStore.getState)
      );
      setPayoutList(response.data || []);
    } catch (error) {
      console.error("Error fetching payouts:", error);
      setError(error.response?.data?.message || "Failed to fetch payouts");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    isMobile&& fetchPayouts();
  }, [isMobile]);
  console.log(isMobile,"isMobileisMobile")
  return (
    <div
      className="PageContainer achievementPageContainer"
      style={{ position: "relative" }}
    >
      <Loader open={openLoader} />{" "}
      <div className="newTabination myprofile-tabination">
        {" "}
        <div
          onClick={() => {
            setMainTabination(0);
          }}
          className={
            "newTabination-item " + (mainTabination === 0 && " active ")
          }
        >
          <div className="svg-con">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="24"
              viewBox="0 0 18 24"
              fill="none"
            >
              <path
                d="M7.69002 5.98316L6.97458 5.75812L7.69002 5.98316ZM5.57042 9.54025L6.02062 8.9404L5.57042 9.54025ZM6.07079 11.131L6.78623 11.3561L6.07079 11.131ZM8.19039 12.7218L7.74019 12.122L8.19039 12.7218ZM9.80961 12.7218L10.2598 12.122L9.80961 12.7218ZM11.9292 11.131L11.2138 11.3561L11.9292 11.131ZM12.4296 9.54025L11.9794 8.9404L12.4296 9.54025ZM10.31 5.98316L11.0254 5.75812L10.31 5.98316ZM12.1701 21.6444L11.6899 22.2205L12.1701 21.6444ZM11.2313 20.8619L11.7115 20.2858H11.7115L11.2313 20.8619ZM6.76871 20.8619L6.28852 20.2858H6.28852L6.76871 20.8619ZM5.82993 21.6444L6.31013 22.2205H6.31013L5.82993 21.6444ZM14.9996 14.3125L14.2498 14.2998L14.2496 14.307L14.2496 14.3142L14.9996 14.3125ZM15 14.2916L14.4377 13.7953L15 14.2916ZM3.0004 14.2921L3.56267 13.7958L3.0004 14.2921ZM6.38004 7.71631C7.31758 7.71631 8.12684 7.09399 8.40546 6.20819L6.97458 5.75812C6.8844 6.0448 6.63594 6.21631 6.38004 6.21631V7.71631ZM6.02062 8.9404C5.76928 8.75176 5.69695 8.45601 5.7855 8.17451C5.87351 7.89471 6.08997 7.71631 6.38004 7.71631V6.21631C4.27098 6.21631 3.5079 8.93003 5.12023 10.1401L6.02062 8.9404ZM6.78623 11.3561C7.06371 10.4739 6.76396 9.49829 6.02062 8.9404L5.12023 10.1401C5.3424 10.3068 5.44667 10.6157 5.35535 10.906L6.78623 11.3561ZM7.74019 12.122C7.49761 12.304 7.23281 12.2807 7.02136 12.122C6.80639 11.9606 6.68379 11.6818 6.78623 11.3561L5.35535 10.906C5.04546 11.8912 5.44292 12.8128 6.12096 13.3217C6.80252 13.8332 7.80368 13.9498 8.64058 13.3217L7.74019 12.122ZM10.2598 12.122C9.5103 11.5594 8.4897 11.5594 7.74019 12.122L8.64058 13.3217C8.8566 13.1595 9.1434 13.1595 9.35942 13.3217L10.2598 12.122ZM11.2138 11.3561C11.3162 11.6818 11.1936 11.9606 10.9786 12.122C10.7672 12.2807 10.5024 12.304 10.2598 12.122L9.35942 13.3217C10.1963 13.9498 11.1975 13.8332 11.879 13.3217C12.5571 12.8128 12.9545 11.8912 12.6447 10.906L11.2138 11.3561ZM11.9794 8.9404C11.236 9.49829 10.9363 10.4739 11.2138 11.3561L12.6447 10.906C12.5533 10.6157 12.6576 10.3068 12.8798 10.1401L11.9794 8.9404ZM11.62 7.71631C11.91 7.71631 12.1265 7.89471 12.2145 8.17451C12.303 8.45601 12.2307 8.75176 11.9794 8.9404L12.8798 10.1401C14.4921 8.93003 13.729 6.21631 11.62 6.21631V7.71631ZM9.59454 6.20819C9.87316 7.09399 10.6824 7.71631 11.62 7.71631V6.21631C11.3641 6.21631 11.1156 6.0448 11.0254 5.75812L9.59454 6.20819ZM11.0254 5.75812C10.3929 3.74729 7.60707 3.74729 6.97458 5.75812L8.40546 6.20819C8.59762 5.59727 9.40238 5.59727 9.59454 6.20819L11.0254 5.75812ZM1.75 9C1.75 4.99594 4.99594 1.75 9 1.75V0.25C4.16751 0.25 0.25 4.16751 0.25 9H1.75ZM9 1.75C13.0041 1.75 16.25 4.99594 16.25 9H17.75C17.75 4.16751 13.8325 0.25 9 0.25V1.75ZM14.25 14.8346V20.3787H15.75V14.8346H14.25ZM3.75 20.3787V14.8346H2.25V20.3787H3.75ZM12.6503 21.0683L11.7115 20.2858L10.7511 21.438L11.6899 22.2205L12.6503 21.0683ZM6.28852 20.2858L5.34973 21.0683L6.31013 22.2205L7.24891 21.438L6.28852 20.2858ZM11.7115 20.2858C11.1938 19.8543 10.7533 19.4854 10.3595 19.2324C9.94762 18.9679 9.51415 18.7807 9 18.7807V20.2807C9.12 20.2807 9.26981 20.3153 9.54887 20.4945C9.84595 20.6853 10.204 20.982 10.7511 21.438L11.7115 20.2858ZM7.24891 21.438C7.79599 20.982 8.15405 20.6853 8.45113 20.4945C8.73019 20.3153 8.88 20.2807 9 20.2807V18.7807C8.48585 18.7807 8.05238 18.9679 7.64053 19.2324C7.2467 19.4854 6.80619 19.8543 6.28852 20.2858L7.24891 21.438ZM2.25 20.3787C2.25 21.1346 2.24796 21.7892 2.32055 22.2768C2.39181 22.7554 2.57441 23.3562 3.19277 23.6328L3.80519 22.2635C3.92457 22.3169 3.85768 22.4151 3.8042 22.0559C3.75204 21.7055 3.75 21.1869 3.75 20.3787H2.25ZM5.34973 21.0683C4.7198 21.5933 4.31089 21.9317 4.0001 22.1232C3.67835 22.3215 3.69524 22.2143 3.80519 22.2635L3.19277 23.6328C3.8017 23.9052 4.3734 23.6551 4.78705 23.4002C5.21167 23.1385 5.71874 22.7134 6.31013 22.2205L5.34973 21.0683ZM14.25 20.3787C14.25 21.1869 14.248 21.7055 14.1958 22.0559C14.1423 22.4151 14.0754 22.3169 14.1948 22.2635L14.8072 23.6328C15.4256 23.3562 15.6082 22.7554 15.6795 22.2768C15.752 21.7892 15.75 21.1346 15.75 20.3787H14.25ZM11.6899 22.2205C12.2813 22.7134 12.7883 23.1385 13.2129 23.4002C13.6266 23.6551 14.1983 23.9052 14.8072 23.6328L14.1948 22.2635C14.3048 22.2143 14.3216 22.3215 13.9999 22.1232C13.6891 21.9317 13.2802 21.5933 12.6503 21.0683L11.6899 22.2205ZM15.75 14.8346C15.75 14.6501 15.75 14.4756 15.7496 14.3109L14.2496 14.3142C14.25 14.4769 14.25 14.6497 14.25 14.8346H15.75ZM16.25 9C16.25 10.8392 15.5661 12.5168 14.4377 13.7953L15.5623 14.7879C16.9233 13.2459 17.75 11.2186 17.75 9H16.25ZM14.4377 13.7953C13.1081 15.3017 11.1653 16.25 9 16.25V17.75C11.6135 17.75 13.9601 16.6033 15.5623 14.7879L14.4377 13.7953ZM15.7495 14.3252L15.7499 14.3044L14.2501 14.2789L14.2498 14.2998L15.7495 14.3252ZM3.75 14.8346C3.75 14.642 3.75 14.4625 3.7504 14.2939L2.2504 14.2903C2.25 14.4611 2.25 14.6424 2.25 14.8346H3.75ZM9 16.25C6.83492 16.25 4.89222 15.3019 3.56267 13.7958L2.43813 14.7884C4.04034 16.6035 6.38674 17.75 9 17.75V16.25ZM3.56267 13.7958C2.43402 12.5172 1.75 10.8394 1.75 9H0.25C0.25 11.2188 1.07685 13.2464 2.43813 14.7884L3.56267 13.7958Z"
                fill="#E6FBFF"
              />
            </svg>
          </div>
          Achievements
        </div>
        {payoutAccess && (
          <>
            <div
              onClick={() => {
                setMainTabination(1);
              }}
              className={
                "newTabination-item " + (mainTabination === 1 && " active ")
              }
            >
              <div className="svg-con">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.38766 21.2632L4.77953 20.6237L4.38766 21.2632ZM2.73695 19.6125L3.37643 19.2206H3.37643L2.73695 19.6125ZM21.2634 19.6125L20.6239 19.2206L21.2634 19.6125ZM19.6126 21.2632L19.2208 20.6237L19.6126 21.2632ZM19.6126 5.7368L19.2208 6.37628L19.6126 5.7368ZM21.2634 7.38751L20.6239 7.77938L21.2634 7.38751ZM4.38766 5.7368L4.77953 6.37628H4.77953L4.38766 5.7368ZM2.73695 7.38751L3.37643 7.77938H3.37643L2.73695 7.38751ZM18.4769 2.54645L19.0182 2.02728V2.02728L18.4769 2.54645ZM3.84437 2.89079L4.29721 3.48865V3.48865L3.84437 2.89079ZM2.85459 3.92267L3.46991 4.35148L2.85459 3.92267ZM19.0002 5.13032H19.7502L19.7501 5.12662L19.0002 5.13032ZM18.3638 13.6137C18.778 13.6137 19.1138 13.2779 19.1138 12.8637C19.1138 12.4494 18.778 12.1137 18.3638 12.1137V13.6137ZM15.6365 12.1137C15.2223 12.1137 14.8865 12.4494 14.8865 12.8637C14.8865 13.2779 15.2223 13.6137 15.6365 13.6137V12.1137ZM10.5002 5.75H13.5002V4.25H10.5002V5.75ZM13.5002 21.25H10.5002V22.75H13.5002V21.25ZM10.5002 21.25C8.84891 21.25 7.66315 21.2492 6.73824 21.1613C5.82449 21.0744 5.24306 20.9078 4.77953 20.6237L3.99578 21.9027C4.7346 22.3554 5.57271 22.5572 6.59626 22.6545C7.60865 22.7508 8.87796 22.75 10.5002 22.75V21.25ZM1.25015 13.5C1.25015 15.1222 1.24936 16.3915 1.34562 17.4039C1.44294 18.4274 1.64472 19.2655 2.09747 20.0044L3.37643 19.2206C3.09238 18.7571 2.92576 18.1757 2.83888 17.2619C2.75094 16.337 2.75015 15.1512 2.75015 13.5H1.25015ZM4.77953 20.6237C4.20767 20.2733 3.72687 19.7925 3.37643 19.2206L2.09747 20.0044C2.57159 20.7781 3.22209 21.4286 3.99578 21.9027L4.77953 20.6237ZM13.5002 22.75C15.1223 22.75 16.3917 22.7508 17.404 22.6545C18.4276 22.5572 19.2657 22.3554 20.0045 21.9027L19.2208 20.6237C18.7572 20.9078 18.1758 21.0744 17.2621 21.1613C16.3371 21.2492 15.1514 21.25 13.5002 21.25V22.75ZM20.6239 19.2206C20.2734 19.7925 19.7926 20.2733 19.2208 20.6237L20.0045 21.9027C20.7782 21.4286 21.4287 20.7781 21.9028 20.0044L20.6239 19.2206ZM19.2208 6.37628C19.7926 6.72672 20.2734 7.20752 20.6239 7.77938L21.9028 6.99563C21.4287 6.22194 20.7782 5.57144 20.0045 5.09732L19.2208 6.37628ZM10.5002 4.25C8.87796 4.25 7.60865 4.24921 6.59626 4.34547C5.57271 4.44279 4.7346 4.64457 3.99578 5.09732L4.77953 6.37628C5.24306 6.09223 5.82449 5.92561 6.73824 5.83873C7.66315 5.75079 8.84891 5.75 10.5002 5.75V4.25ZM2.75015 13.5C2.75015 11.8488 2.75094 10.663 2.83888 9.73809C2.92576 8.82434 3.09238 8.24291 3.37643 7.77938L2.09747 6.99563C1.64472 7.73445 1.44294 8.57256 1.34562 9.59611C1.24936 10.6085 1.25015 11.8778 1.25015 13.5H2.75015ZM3.99578 5.09732C3.22209 5.57144 2.57159 6.22194 2.09747 6.99563L3.37643 7.77938C3.72687 7.20752 4.20767 6.72672 4.77953 6.37628L3.99578 5.09732ZM10.0532 2.75H15.4219V1.25H10.0532V2.75ZM15.4219 2.75C16.2876 2.75 16.8583 2.75173 17.2815 2.81105C17.6798 2.86687 17.8347 2.96039 17.9357 3.06562L19.0182 2.02728C18.595 1.58606 18.066 1.40635 17.4897 1.32557C16.9382 1.24827 16.2435 1.25 15.4219 1.25V2.75ZM10.0532 1.25C8.39302 1.25 7.08509 1.24888 6.04743 1.36609C4.99381 1.4851 4.12984 1.7337 3.39153 2.29293L4.29721 3.48865C4.73494 3.15709 5.29779 2.9603 6.21579 2.85661C7.14974 2.75112 8.35822 2.75 10.0532 2.75V1.25ZM2.75015 10.3956C2.75015 8.63063 2.7511 7.36468 2.85294 6.38472C2.9535 5.41704 3.14565 4.81679 3.46991 4.35148L2.23928 3.49385C1.7091 4.25462 1.47402 5.14188 1.36097 6.22968C1.2492 7.3052 1.25015 8.6627 1.25015 10.3956H2.75015ZM3.39153 2.29293C2.94821 2.62872 2.5596 3.03422 2.23928 3.49385L3.46991 4.35148C3.70149 4.01918 3.98091 3.72823 4.29721 3.48865L3.39153 2.29293ZM19.7501 5.12662C19.7468 4.44995 19.7324 3.86358 19.6476 3.37747C19.5596 2.87228 19.3855 2.41025 19.0182 2.02728L17.9357 3.06562C18.029 3.16295 18.1132 3.30988 18.1699 3.63506C18.2299 3.97932 18.2468 4.44473 18.2502 5.13403L19.7501 5.12662ZM1.25015 10.3956C1.25015 11.3713 1.22999 12.2642 1.25041 13.0202L2.74986 12.9798C2.7301 12.2482 2.75015 11.424 2.75015 10.3956H1.25015ZM21.5001 14.8409H15.6365V16.3409H21.5001V14.8409ZM12.1592 12.8637C12.1592 14.7841 13.7161 16.3409 15.6365 16.3409V14.8409C14.5445 14.8409 13.6592 13.9557 13.6592 12.8637H12.1592ZM13.6592 12.8637C13.6592 11.7716 14.5445 10.8864 15.6365 10.8864V9.38638C13.7161 9.38638 12.1592 10.9432 12.1592 12.8637H13.6592ZM18.3638 12.1137H15.6365V13.6137H18.3638V12.1137ZM13.5002 5.75C14.8848 5.75 15.9451 5.75032 16.8037 5.8033C17.6614 5.85623 18.2611 5.95942 18.7339 6.13895L19.2664 4.73667C18.5863 4.47839 17.8121 4.36267 16.896 4.30615C15.9808 4.24968 14.8675 4.25 13.5002 4.25V5.75ZM18.7339 6.13895C18.9109 6.20619 19.0712 6.2846 19.2208 6.37628L20.0045 5.09732C19.7711 4.95427 19.5262 4.83534 19.2664 4.73667L18.7339 6.13895ZM18.2502 5.13032V5.43781H19.7502V5.13032H18.2502ZM15.6365 10.8864H21.9446V9.38638H15.6365V10.8864ZM22.7502 13.5C22.7502 12.1255 22.7505 11.0077 22.6931 10.0896L21.196 10.1832C21.2498 11.0439 21.2502 12.108 21.2502 13.5H22.7502ZM22.6931 10.0896C22.6147 8.83476 22.4249 7.84749 21.9028 6.99563L20.6239 7.77938C20.9528 8.3161 21.1225 9.00707 21.196 10.1832L22.6931 10.0896ZM21.2502 13.5C21.2502 14.2875 21.2501 14.9722 21.2401 15.5785L22.7399 15.6034C22.7502 14.9821 22.7502 14.2839 22.7502 13.5H21.2502ZM21.2401 15.5785C21.2075 17.537 21.0636 18.5031 20.6239 19.2206L21.9028 20.0044C22.583 18.8944 22.7079 17.5313 22.7399 15.6034L21.2401 15.5785ZM21.5001 16.3409H21.99V14.8409H21.5001V16.3409Z"
                    fill="#E6FBFF"
                  />
                </svg>
              </div>
              Payout
            </div>
          </>
        )}
      </div>{" "}
      <div className="mobileTabOption">
        <MobileTabs
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabItems={tabItems}
        />
      </div>{" "}
      {mainTabination === 0 && (
        <>
          <Certificates />
        </>
      )}
      {mainTabination === 1 && (
        <>
          {!requestPayout ? (
            <>
              <div
                className="DpboxCon PayoutContainer"
                style={{ border: 0, padding: 0 }}
              >
                <Typography className="payout-heading">
                  Welcome to my Payout
                </Typography>
              </div>
              <Grid2
                container
                item
                className="gen-info-form reqPayoutBox"
                spacing={0}
                width={"100%"}
              >
                <Grid2
                  item
                  xs={12}
                  md={12}
                  lg={9}
                  gap={"20px"}
                  display={"flex"}
                  style={{ width: "100%" }}
                >
                  <div className="form-grp-in" style={{ width: "100%" }}>
                    <Grid2
                      container
                      className="container-box "
                      xs={12}
                      md={11.7}
                      style={{ width: "100%" }}
                    >
                      <Grid2 item xs={12} md={7} className="payoutLeftSection">
                        <div className="payoutTopSection">
                          {" "}
                          <Typography className="payout-heading">
                            <p className="mainHeader">
                              Ready to request Your Payout
                            </p>
                            <p className="subHeader">
                              Please click on the request payout button and
                              proceed to fill out the needed information; our
                              staff will contact you for further developments.
                            </p>
                          </Typography>
                          <div className="reqPayoutBtn">
                            <button
                              onClick={() => {
                                setRequestPayout(true);
                              }}
                              className="payoutButton"
                            >
                              <CardIcon />
                              Request Payout
                            </button>
                          </div>
                        </div>

                        <div className="payout-Note">
                          <EditSquareIcon />
                          <p>
                            Note: Please wait for at least 15mins after you
                            close your latest trade to request a payout.
                          </p>
                        </div>
                      </Grid2>
                    </Grid2>
                  </div>
                </Grid2>
              </Grid2>
              <div className="payoutTableContainer">
                {!isMobile ? (
                  <div className="payoutTableWrapper">
                    <PayoutTable />
                  </div>
                ) : (
                  false
                )}
                {isMobile ? (
                  <div className="Historymobile">
                    {payoutList.map((item) => (
                      <div className="Box mbb-10">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center gapp-10">
                            <Title four>{item.id}</Title>
                            <div className="Date">
                              {formatDateTime(item.created_at)}
                            </div>
                          </div>
                          <div
                            className="approvedDisapprovedDiv"
                            // style={{
                            //   display: "flex",
                            //   flexDirection: "row-reverse",
                            //   gap: "1rem",
                            // }}
                          >
                            {item.invoice ? (
                              <a
                                href={item.invoice}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <img src={downloadIcon} alt="" />
                              </a>
                            ) : (
                              "N/A"
                            )}
                            {StatFormatter(String(item?.status).toLowerCase())}
                          </div>
                        </div>
                        <div className="d-flex justify-content-between mtt-20 BoxS">
                          <HeadAndDesc
                            HeadTitle="Payout Type"
                            SubTitle={item.type}
                          />
                          <HeadAndDesc
                            // SubTitleClass="paymentTD"
                            HeadTitle="Method"
                            SubTitle={item.method}
                          />
                          <HeadAndDesc
                            HeadTitle="Amount"
                            SubTitle={dollarUS(item.amount)}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  false
                )}
              </div>
            </>
          ) : (
            <RequestPayout close={setRequestPayout} />
          )}
        </>
      )}
    </div>
  );
};

export default AchievementPage;
